import { doc, onSnapshot } from "firebase/firestore";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { ChatContext } from "../../context/ChatContext";
import { db } from "../../firebase";

export const Chats = () => {
  const [chats, setChats] = useState([]);

  const { currentUser } = useContext(AuthContext);
  const { dispatch } = useContext(ChatContext);

  // console.log(currentUser);

  useEffect(() => {
    const getChats = () => {
      const unsub = onSnapshot(doc(db, "userChats", currentUser.uid), (doc) => {
        setChats(doc.data());
        // console.log(doc.data());
      });
      
      return () => {
        unsub();
      };
      // unsub();
    };
    
    if (currentUser.uid) {
      getChats();
    }
    
  }, [currentUser.uid]);
  // console.log(Object.entries(chats));
  // console.log(chats);
  // console.log(Object.entries(chats));
  
  const handleSelect = (u) => {
    dispatch({type: "CHANGE_USER", payload: u})
  };

  return (
    <div className="chats">
      {Object.entries(chats)?.sort((a,b)=>b[1].date-a[1].date)?.map((chat) => (
        <div className="userChat" key={chat[0]} onClick={() => handleSelect(chat[1]?.userInfo)}>
          <img
            src={chat[1]?.userInfo?.photoURL}
            alt=""
          />
          <div className="userChatInfo">
            <span>{chat[1]?.userInfo?.firstName}</span>
            <p>{chat[1]?.lastMessage?.text}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
